import { useSelector } from "react-redux";
import { useTranslation } from "translation/useTranslation";

export default function FixInfo({ budgetName, errorKey }) {
  const { editableTranslate } = useTranslation();

  return <div className="alert alert-info">
    <div className="d-flex align-items-baseline">
      <span className="bi bi-info-circle-fill mr-2"></span>
      <div>
        {editableTranslate('calculation_overview.redirect_info')}
        <div className="mt-2">
          <div>{editableTranslate('budget_setting.budget_name')}: <span className="font-weight-bold">{budgetName}</span></div>
          {editableTranslate('calculation_overview.fix_required')}: <span className="font-weight-bold">{editableTranslate('calculation_overview.fix_' + errorKey)}</span>
        </div>
      </div>
    </div>
  </div>
}
